import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';

import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { ConfigurationService } from '../../../core/_infrastructure/classes/services/configuration.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { BuscadorAtestacionService } from './buscador-atestacion.service';
import {
    SolicitudAtestFitoItemResultsViewModel,
    FilterSearchingSolicitudAtestFitoViewModel,
    SolicitudAtestFitoItemViewModel,
} from './buscador-atestacion.types';
import { catchError, of, tap } from 'rxjs';
import { Tc, TcPerfilUsuarioEnum } from '../../../core/_infrastructure/types/common';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { EnumIdsTcEstadoSolicitudAtestFito } from '../../atestaciones/types/enum';
import { SolicitudAtestFitoViewModel } from '../../atestaciones/datosbasicos/datosbasicosAtestFito.types';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-buscador-atestacion-list',
    templateUrl: './buscador-atestacion-list.component.html',
})
export class BuscadorAtestacionListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    resultSolicitudesAtest: SolicitudAtestFitoItemResultsViewModel;
    listPais: Tc[];
    listTipoSolicitud: Tc[];
    listProvincia: Tc[];
    listComunidad: Tc[];
    listEstado: Tc[];
    firstDayMonth: Date;
    lastDayMonth: Date;
    cols: any[];

    public isCollapsed = false;

    visibilitySpinner = false;
    habilitarNueva = true;

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected navMenuService: NavMenuService,
        protected exceptionHandler: ExceptionManager,
        protected configurationService: ConfigurationService,
        private confirmationService: ConfirmationService,
        private buscadorAtestacionService: BuscadorAtestacionService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultSolicitudesAtest = new SolicitudAtestFitoItemResultsViewModel();
    }

    ngOnInit() {
        this.navMenuService.resetSolicitudData();

        this.habilitarNueva = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_ATESTACION).Visible;

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Image', header: '' },
            { field: 'RefAtestFito', header: 'Ref. Atestación' },
            { field: 'RefSolicitante', header: 'Ref. Solicitante' },
            { field: 'FechaEnvio', header: 'Fecha' }, // | date:'dd/MM/yyyy'
            //{ field: 'HoraEnvio', header: 'Hora' }, // | date:'dd/MM/yyyy'
            //{ field: 'TipoSolicitudAtestFito', header: 'Tipo' },
            { field: 'ComunidadAutonoma', header: 'Comunidad Autónoma' },
            { field: 'RazonSocial', header: 'Solicitante' },
            { field: 'Provincia', header: 'Provincia' },
            //{ field: 'Estado', header: 'Estado' },
            { field: 'PaisDestino', header: 'País Destino' },
            { field: 'UsuarioCa', header: 'Usuario CA' },
            { field: 'FechaValidezInicio', header: 'Fecha Validez Inicio' }, // | date:'dd/MM/yyyy'
            { field: 'FechaValidezFin', header: 'Fecha Validez Fin' }, // | date:'dd/MM/yyyy'
            { field: 'FechaInspeccion', header: 'Fecha Inspección' },
            //{ field: 'HoraInspeccion', header: 'Hora Inspección' },
            { field: 'NombreTecResponsable', header: 'Técnico Responsable / AC' },
            { field: 'IdTipoSolicitudInfCa', header: 'IdTipoSolicitudInfCa', display: 'none' },
            { field: 'IdEstado', header: 'IdEstado', display: 'none' },
        ];

        this.globalService.getAllPaisesExpor().subscribe(res => {
            this.listPais = res;
        });
        this.globalService.getTipoSolicitudAtestFito().subscribe(res => {
            this.listTipoSolicitud = res;
        });
        this.globalService.getComunidadesAutonomas().subscribe(res => {
            this.listComunidad = res;
        });
        this.globalService.getEstadoSolicitudAtestFito().subscribe(res => {
            this.listEstado = res;
        });

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        this.form = this.fb.group({
            RefAtestFito: '',
            IdEstado: null,
            IdPaisDestino: null,
            IdTipoSolicitudInfCa: null,
            IdProvincia: null,
            IdCa: null,
            NombreTecResponsable: '',
            RazonSocial: '',
            FechaRegistroDesde: this.firstDayMonth,
            FechaRegistroHasta: this.lastDayMonth,
            FechaValidezDesde: null,
            FechaValidezHasta: null,
            FechaInspeccionDesde: null,
            FechaInspeccionHasta: null,
        });

        this.loadBack();
    }

    loadBack(): void {
        if (
            this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaRegistroDesde == null ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaRegistroHasta == null ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.IdEstado != null ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.IdTipoSolicitudInfCa != null ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.IdPaisDestino != null ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.IdProvincia != null ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.IdCa != null ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.RefAtestFito != '' ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.NombreTecResponsable != '' ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.RazonSocial != '' ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaValidezDesde != null ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaValidezHasta != null ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaInspeccionDesde != null ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaInspeccionHasta != null ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaRegistroDesde!.toString() != this.firstDayMonth.toString() ||
            this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaRegistroHasta!.toString() != this.lastDayMonth.toString()
        ) {
            this.form.patchValue({
                IdEstado: this.buscadorAtestacionService.currentFilterSolicitudAtest.IdEstado,
                IdPaisDestino: this.buscadorAtestacionService.currentFilterSolicitudAtest.IdPaisDestino,
                IdProvincia: this.buscadorAtestacionService.currentFilterSolicitudAtest.IdProvincia,
                IdCa: this.buscadorAtestacionService.currentFilterSolicitudAtest.IdCa,
                IdTipoSolicitudInfCa: this.buscadorAtestacionService.currentFilterSolicitudAtest.IdTipoSolicitudInfCa,
                RefAtestFito: this.buscadorAtestacionService.currentFilterSolicitudAtest.RefAtestFito,
                NombreTecResponsable: this.buscadorAtestacionService.currentFilterSolicitudAtest.NombreTecResponsable,
                RazonSocial: this.buscadorAtestacionService.currentFilterSolicitudAtest.RazonSocial,
                FechaValidezDesde: this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaValidezDesde,
                FechaValidezHasta: this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaValidezHasta,
                FechaInspeccionDesde: this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaInspeccionDesde,
                FechaInspeccionHasta: this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaInspeccionHasta,
                FechaRegistroDesde: this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaRegistroDesde,
                FechaRegistroHasta: this.buscadorAtestacionService.currentFilterSolicitudAtest.FechaRegistroHasta,
            });

            this.onSearchButton();
        }
    }

    onSearchButton(): void {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }
        this.Search(0);
        this.searchingButton = true;
        this.isCollapsed = true;
    }

    CreateModel(): FilterSearchingSolicitudAtestFitoViewModel {
        let model: FilterSearchingSolicitudAtestFitoViewModel = new FilterSearchingSolicitudAtestFitoViewModel();

        model.FechaRegistroDesde = this.form.value.FechaRegistroDesde;
        model.FechaRegistroHasta = this.form.value.FechaRegistroHasta;
        model.FechaValidezDesde = this.form.value.FechaValidezDesde;
        model.FechaValidezHasta = this.form.value.FechaValidezHasta;
        model.FechaInspeccionDesde = this.form.value.FechaInspeccionDesde;
        model.FechaInspeccionHasta = this.form.value.FechaInspeccionHasta;

        model.RefAtestFito = this.form.value.RefAtestFito;
        model.NombreTecResponsable = this.form.value.NombreTecResponsable;
        model.IdPaisDestino = this.form.value.IdPaisDestino;
        model.IdTipoSolicitudInfCa = this.form.value.IdTipoSolicitudInfCa;
        model.IdEstado = this.form.value.IdEstado;
        if ((model.IdCa === null || model.IdCa === 0 || model.IdCa === undefined) && this.isCA) {
            model.IdCa = this.loggedInUser!.TwUsuarioCa.IdCa;
        } else {
            model.IdCa = this.form.value.IdCa;
        }
        model.IdProvincia = this.form.value.IdProvincia;
        model.IdUsuario = this.loggedInUser!.Id;
        model.RazonSocial = this.form.value.RazonSocial;
        model.IdPaisDestino = this.form.value.IdPaisDestino;

        model.EsInspector = this.isInspector;
        model.EsCoordinador = this.isCoordinador;
        model.EsSolicitante = this.isSolicitante;
        model.EsAgenteControl = this.isAC;
        model.EsComunidadAutonoma = this.isCA;

        return model;
    }

    Search(pageNumber: number, asc = 0, orderBy = ''): void {
        let model: FilterSearchingSolicitudAtestFitoViewModel = this.CreateModel();

        model.PageNumber = pageNumber;
        model.Asc = asc;
        model.OrderBy = orderBy;

        //Todo:agaro. 23/01/2020.
        //Establecer la hora de la fecha Hasta si tiene valor a las 23:59:59, que solo lo hace si no se selecciona y no se estaba teniendo
        //en cuenta el propio día de la fecha hasta.
        if (model.FechaRegistroHasta != null) {
            model.FechaRegistroHasta.setHours(23);
            model.FechaRegistroHasta.setMinutes(59);
            model.FechaRegistroHasta.setSeconds(59);
        }

        this.buscadorAtestacionService
            .postSolicitudPagedByFilter(model)
            .pipe(
                tap(result => {
                    this.resultSolicitudesAtest = result;
                    this.loading = false;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.form?.disable();
                    return of(null);
                }),
            )
            .subscribe();

        this.buscadorAtestacionService.currentFilterSolicitudAtest = model;
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link' || event.sortField == 'Image') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.setValue({
            RefAtestFito: '',
            IdEstado: null,
            IdPaisDestino: null,
            IdTipoSolicitudInfCa: null,
            IdProvincia: null,
            IdCa: null,
            NombreTecResponsable: '',
            RazonSocial: '',
            FechaRegistroDesde: this.firstDayMonth,
            FechaRegistroHasta: this.lastDayMonth,
            FechaValidezDesde: null,
            FechaValidezHasta: null,
            FechaInspeccionDesde: null,
            FechaInspeccionHasta: null,
        });

        this.isCollapsed = false;
        this.searchingButton = false;

        this.resultSolicitudesAtest = new SolicitudAtestFitoItemResultsViewModel();
    }

    onSelectComunidad(): void {
        const idCA = this.form.value.IdCa;

        this.globalService.getProvinciasByComunidad(idCA).subscribe(res => {
            this.listProvincia = res;
        });

        this.form.patchValue({
            IdProvincia: null,
        });
    }

    onSelectEstado(): void {
        //Si es borrador, limpiamos las fechas
        if (this.form.value.IdEstado == EnumIdsTcEstadoSolicitudAtestFito.ID_BORRADOR) {
            this.form.patchValue({
                FechaRegistroDesde: null,
                FechaRegistroHasta: null,
            });
        }
    }

    //revisar ruta en el module
    onAdd(): void {
        this.navMenuService.currentSolicitudAtestacion = new SolicitudAtestFitoViewModel();
        this.router.navigate(['/exportacion/atestacion/tipossolicitudesAtestFito']);
    }

    //revisar ruta en el module
    onEdit(item: SolicitudAtestFitoViewModel): void {
        this.router.navigate(['/exportacion/atestacion/datosbasicos', item.Id]);
    }

    onDelete(item: SolicitudAtestFitoViewModel): void {
        this.confirmationService.confirm({
            message: '¿Está seguro de eliminar la solicitud?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.buscadorAtestacionService
                    .deleteSolicitud(item.Id)
                    .pipe(
                        tap(() => {
                            this.addSuccessMessage('Solicitud eliminada correctamente');
                            this.onSearchButton();
                        }),
                        catchError(error => {
                            this.catchServerError(error);
                            this.form?.disable();
                            return of(null);
                        }),
                    )
                    .subscribe();
            },
        });
    }

    checkDelete(rowData: SolicitudAtestFitoItemViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.ELIMINAR_SOLICITUD_ATESTACION, rowData.IdEstado).Visible && rowData.EsVisibleEdicion;
    }

    onExportExcel(): void {
        this.visibilitySpinner = true;
        this.buscadorAtestacionService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    exportIsAvailable(): boolean {
        return this.resultSolicitudesAtest?.ResultList ? this.resultSolicitudesAtest?.ResultList?.length > 0 : false;
    }
}
